<script lang="ts">
	import P from "#lib/components/P.svelte";
	import type { ComponentEditingProps } from "#lib/components/page/ComponentProps.js";
	import EditorInset from "#lib/components/page/editing/EditorInset.svelte";

	const _: ComponentEditingProps = $props();

	export function validate(): boolean {
		return true;
	}
</script>

<EditorInset>
	<div class="mx-6 rounded-lg border p-8">
		<P weight="semibold" align="center" secondary>This component has no additional configuration options.</P>
		<P size="sm" align="center" secondary>Use the "Content" tab to manage the listing details associated with this flow.</P>
	</div>
</EditorInset>
